import BaseApiService from "./BaseApiService";
import qs from "qs";

const messageHandlerApiPath = process.env.REACT_APP_MESSAGE_HANDLER_SCHEDULE_URL;
const code = process.env.REACT_APP_SCHEDULE_API_CODE;

const _scheduleMessage = (payload, code) => {
  const encodedPayload = qs.stringify(payload);
  return BaseApiService.post(`${messageHandlerApiPath}/api/v1/scheduleMessage?code=${code}`,null,encodedPayload,false,{},{"Content-Type": "application/x-www-form-urlencoded"});
};
const _messageListing = (section) => {
  return BaseApiService.get(`${messageHandlerApiPath}/api/v1/schedule_messages/${section}/list?code=${code}`,null,false);
};

const _messageDelete = (section, id, partitionKey) => {
  return BaseApiService.delete(
    `${messageHandlerApiPath}/api/v1/schedule_messages/${section}/delete/${id}/${partitionKey}?code=${code}`,
    null,
    null,
    false
  );
};

const _messageCreation = (section, payload) => {
  return BaseApiService.post(
    `${messageHandlerApiPath}/api/v1/schedule_messages/${section}/create?code=${code}`,
    null,
    payload,
    false,
    {}
  );
};

const _message_Edit = (section, payload, id, partitionKey) => {
  return BaseApiService.put(
    `${messageHandlerApiPath}/api/v1/schedule_messages/${section}/update/${id}/${partitionKey}?code=${code}`,
    null,
    payload,
    false
  );
};

export const ScheduleMessageApiService = {
  scheduleMessage: _scheduleMessage,
  messageListing: _messageListing,
  messageCreation: _messageCreation,
  messageEdit: _message_Edit,
  messageDelete: _messageDelete,
};
